module.exports = __webpack_public_path__ + "media/members/photo-a420c0dd.png";